// extracted by mini-css-extract-plugin
export default {"root":"Info-root","text":"Info-text","infoWrap":"Info-infoWrap","buttonWrap":"Info-buttonWrap","noProfile":"Info-noProfile"};